import { styled } from 'styled-components';
import ActionButton from './ActionButton';

const NegativeActionButton = styled(ActionButton)`
  background: ${props => props.theme.colors.negativeActionButtonBackground};
`;

export default NegativeActionButton;
